import store from 'Redux/store';
import { getPersistedRecentlyViewedSlugs } from 'Api/RecentlyViewed/utility';
import { USER_RECOMMENDATIONS_FETCH } from 'Redux/reducers/user-recommendations';
import { getUserRecommendations } from 'Api/Recommendations/user-recommendations';

/* eslint-disable import/prefer-default-export */

export async function fetchAndDispatchUserRecommendations() {
  const recentlyViewedSlugs = getPersistedRecentlyViewedSlugs();

  return getUserRecommendations(recentlyViewedSlugs)
    .then((hits) => {
      store.dispatch({ type: USER_RECOMMENDATIONS_FETCH, payload: hits });
    })
    .catch(() => {});
}
